/* eslint-disable prettier/prettier */
import { makeStyles } from '@material-ui/core/styles'
// export default makeStyles((theme)=>{
export default makeStyles({
  selected: {
    color: '#b779ff'
  }
})